// extracted by mini-css-extract-plugin
module.exports = {"GoodsMore":"GoodsMore_GoodsMore__OBBk_"};